
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 70 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M63.153 4.534l1.276 7.909h-2.554l1.278-7.91zm6.845 13.81L67.054 1.656h-7.802l-2.944 16.688h4.616l.614-3.845h3.238l.61 3.845h4.612zm-19.799 0h4.907V1.656h-4.907v16.688zm-6.65-9.19c-1.324-.505-1.594-.799-1.594-1.258 0-.581.49-.895 1.521-.895 1.423 0 2.993.483 4.514 1.088V2.696c-1.054-.871-2.943-1.403-4.882-1.403-3.364 0-5.373 1.596-5.373 4.426 0 2.467 1.276 3.628 4.196 4.692l1.08.388c1.176.432 1.57.75 1.57 1.281 0 .411-.246.92-1.473.92-1.693 0-3.73-.823-5.128-1.573v6.023c1.325.677 3.41 1.257 5.472 1.257 3.51 0 5.52-1.451 5.52-4.547 0-2.104-.859-3.29-4.146-4.523l-1.276-.484zM32.829 10c0 1.91-.76 3.023-2.527 3.023-1.766 0-2.527-1.114-2.527-3.023 0-1.91.76-3.023 2.527-3.023 1.767 0 2.527 1.112 2.527 3.023zM30.3 1.293c-5.153 0-6.455 3.918-6.455 8.707 0 4.813 1.3 8.707 6.453 8.707 5.153 0 6.452-3.893 6.452-8.707 0-4.789-1.3-8.707-6.452-8.707h.002zm-11.9 5.925c1.473 0 2.576.433 4.147 1.282V3.01c-.908-.992-2.748-1.717-4.588-1.717-4.22 0-6.474 2.66-6.474 8.707 0 5.466 1.84 8.707 6.502 8.707 1.816 0 3.656-.725 4.563-1.741v-5.467c-1.57.847-2.673 1.283-4.146 1.283-1.938 0-2.993-.678-2.993-2.806s1.447-2.758 2.993-2.758h-.003zm-8.04-5.562H0v16.688h10.354v-5.32H3.926v-2.008h4.168V8.983H3.926V6.977h6.428l.007-5.321z","fill":"currentColor"}})])
          )
        }
      }
    